import { createSelector } from 'reselect';

const getAdminSelectors = pageName => {
  const fetchingEntitiesSelector = state =>
    state.administration[pageName].fetchingEntities;

  const savingEntitySelector = state =>
    state.administration[pageName].savingEntity;

  const uploadingEntitiesSelector = state =>
    state.administration[pageName].uploadingEntities;

  const importingEntitiesSelector = state =>
    state.administration[pageName].importingEntities;

  const entitiesSelector = state =>
    state.administration[pageName].entities;

  const uploadedEntitiesSelector = state =>
    state.administration[pageName].uploadedEntities;

  const removingEntitySelector = state =>
    state.administration[pageName].removingEntity;

  const areImportsPendingSelector = createSelector(
    uploadedEntitiesSelector,
    uploadedRates => !(uploadedRates.some(({ validationData }) => !!validationData)
      || uploadedRates.length === 0));

  const isBusySelector = createSelector(
    fetchingEntitiesSelector,
    savingEntitySelector,
    importingEntitiesSelector,
    removingEntitySelector,
    (...args) => args.some(Boolean)
  );


  return {
    fetchingEntitiesSelector,
    savingEntitySelector,
    uploadingEntitiesSelector,
    importingEntitiesSelector,
    entitiesSelector,
    uploadedEntitiesSelector,
    removingEntitySelector,
    areImportsPendingSelector,
    isBusySelector,
  };
};

export default getAdminSelectors;
